import { Auth } from "./auth";

const { AUTHORITY_DOMAIN, INSTANCE, DOMAIN, SIGNIN_SIGNUP_POLICY_ID } = Auth;

export const policies = {
  names: {
    signUpSignIn: SIGNIN_SIGNUP_POLICY_ID,
  },
  authorities: {
    signUpSignIn: {
      authority: `${INSTANCE}/${DOMAIN}/${SIGNIN_SIGNUP_POLICY_ID}`,
    },
  },
  authorityDomain: AUTHORITY_DOMAIN,
};
